import React from 'react';

export default ({svg, onClick, className=''})=> (
	<span className={`Icon ${className}`} aria-hidden='true' dangerouslySetInnerHTML={{__html: svg}} onClick={onClick}/>
);